import React from 'react';
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react';
import { jumpTo } from '@/navigate'
import Tips from "../../components/tips";
import BgAudio from "./bgAudio";
import scene from '../three/index';
import './index.scss';
@inject('ScoreStore')
@observer
class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            display: true,
            getScore: false,
            zhenhot:[]
        }
    }
    componentWillMount(){
        let s = scene;
        let zhens = s.placedYinzhen?s.placedYinzhen:[];
        this.setState({zhenhot: zhens.map(item=>{ return {name: item.placeName} })});
    }

    componentDidMount() {
        let s = scene;
         
        // let zhens = s.placedYinzhen;
        // this.setState({zhenhot: zhens.map(item=>{ return {name: item.placeName} })})
        console.log( this.state.zhenhot );

        s.init(this.refs.container, () => {
            
            let zhenhot = scene.placedYinzhen?scene.placedYinzhen:[];
            
            // zhenhot.forEach(item=>{
            //     console.log( this.refs[item.placeName]);
            // }); 

            s.changeState(2, zhenhot.map(item=>{
                return {dom: this.refs[item.placeName], name: item.placeName}
            }));
        });
        this.threescene = s;
        let userInput = toJS(this.props.ScoreStore.userInput);
        let xueIndex = userInput.indexOf("神阙");
        if (xueIndex != -1) {
            userInput.splice(xueIndex, 1)
        }
        let len = userInput.length;
        let posArr = [["qimen", "qimen2"], ["tianshu", "tianshu2"], ["shangjuxu", "shangjuxu2"], ["sanyinjiao", "sanyinjiao2"], ["taichong", "taichong2"]]
        let prePos = "", getScore = true;
        window.Bus.on("zhenout", (name) => {
            if (name == "shenque") {
                return false;
            }
            len = len - 1;
            if (getScore) {
                for (let i = 0; i < posArr.length; i++) {
                    let index = posArr[i].indexOf(name);
                    if (index != -1) {
                        if (!prePos) {
                            prePos = i;
                        }
                        else {
                            if (i >= prePos) {
                                getScore = true;
                            }
                            else {
                                getScore = false;
                            }
                        }
                        break;
                    }
                }
                if (name == "dachangyu" || name == "dachangyu2") {
                    if (!prePos || len == 0 || len == 1) {
                        getScore = true;
                    }
                    else {
                        getScore = false;
                    }
                }
            }
            if (len == 0) {
                this.setState({
                    getScore: getScore
                })
            }
        });

    }
    nextStep() {
        if (this.state.getScore) {
            this.props.ScoreStore.addScore(1);
        }
        else {
            this.props.ScoreStore.setPenalties("出针顺序", 1);
        }
        jumpTo("guide8")
    }
    hideTips() {
        this.setState({
            display: false
        })
    }
    render() {
        return (
            <div className="page page-guide guide_room_2">
                <div className="threescene" ref="container"></div>
                {this.state.display &&
                    <div className={"form_view"}>
                        <div className="form_tips">点击相应穴位，确认出针顺序出针时按压穴位，预防出血</div>
                        <div className="form_btn txt_c">
                            <button onClick={() => { this.hideTips() }}>知道了</button>
                        </div>
                    </div>
                }
                <div className="finish_btn"><button onClick={() => { this.nextStep() }}>完成拔针</button></div>
                <audio src={require("../../assets/audio/step_7.mp3")} autoPlay={true} />
                <Tips init={false} studyTips={3}/>
                <BgAudio />
                {
                    this.state.zhenhot.map(item=>( <img src={require("../../assets/hot.png")} className="anchor-image" key={item.name} ref={item.name} /> ))
                }
            </div>
        );
    }
}

export default App;
